import { FileService } from "./file.service";

export const canRecordAssetView = (asset) => {
  if (!asset) {
    return;
  }
  var fileType = FileService.getFileType(asset.metadata);

  switch (fileType) {
    case "VIDEO":
    case "YOUTUBE":
    case "VIMEO":
    case "WISTIA":
    case "AUDIO":
      return false;
    default:
      return true;
  }
};


export const getFullName = (user) => {
  if(!user) {
    return "";
  }
  return `${user.firstName || ""} ${user.lastName || ""}`;
};